<template>
  <div class="lti-content">
    <div class="d-flex w-100 bg"
         style="flex-direction: column;">
      <component :is="tagName" :src="src"
                 :srtUrl="srtUrl"
                 :onReady="onVideoPlayerReady"
                 :onTimeUpdate="onTimeUpdate"
                 :style="{'opacity': isLoading ? 0 : 1}"
                 :alt="tagName === 'img' ? (asset.variants_data.description || null) : null"
                 :title="tagName === 'img' ? (asset.variants_data.name || null) : null"
                 autoplay
                 controls
                 disablePictureInPicture
                 controlsList="nodownload"
                 oncontextmenu="return false"
                 ref="iframeRef"
                 width="100%"
                 height="100%"
                 component="view" >

      </component>
    </div>
    <div class="loader-block bg-transparent" v-if="isLoading">
      <div class="loading">
        <div class="effect-1 effects"></div>
        <div class="effect-2 effects"></div>
        <div class="effect-3 effects"></div>
      </div>
    </div>
  </div>
</template>

<script>
import getLtiPreviewSrc from "@/utils/getLtiPreviewSrc.js";
import VideoPlayer from "@/components/video-player/video-player.vue";
import axios from "axios";

const elementsByType = {
  "3D": "iframe",
  "coobos": "iframe",
  "activities": "iframe",
  "simulations": "iframe",
  "image": "img",
  "illustration": "img",
  "videos": "VideoPlayer",
  "animation": "VideoPlayer",
}

export default {
  components: {
    VideoPlayer,
  },
  props: {
    asset: {type: Object},
    userId: {type: String, default: ""},
    locale: {type: String, default: "en"},
    token: {type: String, default: ""}
  },
  data() {
    return {
      src: "",
      srtUrl: "",
      isLoading: true,
      duration: 0,
      maxCurrentTime: 0,
      mountedTs: 0,
    }
  },
  mounted() {
    console.log(this.asset)
    getLtiPreviewSrc(this.asset, this.token, this.locale).then(({src, srtUrl}) => {
      this.mountedTs = Date.now();
      this.src = src;
      this.srtUrl = srtUrl;
      if (this.$refs.iframeRef && this.tagName !== 'VideoPlayer') {
        this.$refs.iframeRef.addEventListener("load", () => {
          if (this.asset.asset_type === "3D") {
            window.addEventListener("message", this.onAssetReady);
          } else {
            this.isLoading = false;
          }
        })
      }
      document.addEventListener("visibilitychange", this.onVisibilityChange);
    })
    this.analytics({
      eventName: "asset_loaded",
      asset_type: this.asset.asset_type,
      variation_id: this.asset.variants_data ? this.asset.variants_data.id : (this.asset.embibeId || ""),
    })
  },
  beforeDestroy() {
    window.removeEventListener("message", this.onAssetReady);
    document.removeEventListener("visibilitychange", this.onVisibilityChange);
  },
  methods: {
    analytics(payload) {
      const filters = {...this.filtersObj};
      delete filters.size;
      const data = {
        app_name: "amp",
        timestamp: Date.now().toString(),
        userId: this.userId,
        ...payload
      }

      const url = "https://beta-api.embibe.com/de/events/push/v2?namespace=prod-embibe-clickstream-events&topic=prod-embibe-clickstream-interaction-events-web";

      return axios.post(url, data);
    },
    onVisibilityChange() {
      if (document.visibilityState === "hidden") {
        this.sendCurrentTimeSpent();
      }
    },
    onTimeUpdate(currentTime, duration) {
      this.duration = duration;
      this.maxCurrentTime = Math.max(currentTime, this.maxCurrentTime);
    },
    onVideoPlayerReady() {
      this.isLoading = false;
    },
    sendCurrentTimeSpent() {
      const {id} = this.$route.params;
      const assetType = this.asset.asset_type;
      const isVideo = ["videos", "animation"].includes(assetType)
      const analyticsData = {
        "app_name": "amp",
        "timestamp": Date.now(),
        "eventName": "asset_playback",
        "asset_type": isVideo ? "video" : assetType,
        "content_id": id,
        "playback_duration": isVideo ? this.maxCurrentTime : Date.now() - this.mountedTs,
        "userId": this.userId,
      };
      if (isVideo) {
        analyticsData["total_duration"] = this.duration;
      }
      navigator.sendBeacon("https://beta-api.embibe.com/de/events/push/v2?namespace=prod-embibe-clickstream-events&topic=prod-embibe-clickstream-interaction-events-web", JSON.stringify(analyticsData));
    },
    onAssetReady(e) {
      if (this.src.startsWith(e.origin) && e.data && e.data.action === "assetReady") {
        this.isLoading = false;
      }
    },
  },
  computed: {
    tagName() {
      return elementsByType[this.asset.asset_type]
    }
  }
}
</script>
<style>
.lti-content {
  width: 100%;
  height: 100%;
  display: flex;
  user-select: none;
}
.lti-content iframe {
  border: none;
}

.lti-content img {
  object-fit: contain;
  background-image: linear-gradient(45deg, #888 25%, transparent 25%, transparent 75%, #888 75%, #888 100%),linear-gradient(45deg, #888 25%, #7d7d7d 25%, #7d7d7d 75%, #888 75%, #888 100%);
  background-position: 0 0, 10px 10px;
  background-size: 20px 20px;
}

.lti-content video {
  background: black;
}

.loader-block .loading {
  top: 50%;
}
.video-js {
  width: 100%;
  height: 100%;
}
</style>
